module.exports = __webpack_public_path__ + "media/images/banner-mobile-cd6a60e5.jpg";